// extracted by mini-css-extract-plugin
export default {"custum_file_upload":"add_custum_file_upload__7d-h-","icon":"add_icon__loVuk","text":"add_text__HRAUj","display_image":"add_display_image__7ipvw","select":"add_select__W79cH"};